const vagas_por_tipo_de_deficiencia = {
  path: "/manutencao_vagas_tipo_deficiencia",
  redirect: "/manutencao_vagas_tipo_deficiencia",
  meta: {
    breadCrumb: "Gerenciamento de Matrícula - Parâmetros de Atendimento",
  },
  children: [
    {
      path: "/manutencao_vagas_tipo_deficiencia/novo",
      name: "manutencaovagastipodeficiencia_novo",
      meta: {
        allowedPermissions: ["deficiencia_vaga_create"],
      },
      component: () =>
        import(
          "@/views/ManutencaoVagasTipoDeficiencia/ManutencaoVagasTipoDeficienciaCad.vue"
        ),
    },
    {
      path: "/manutencao_vagas_tipo_deficiencia/edit/:id",
      name: "manutencaovagastipodeficiencia_atualizar",
      meta: {
        allowedPermissions: ["deficiencia_vaga_edit"],
      },
      component: () =>
        import(
          "@/views/ManutencaoVagasTipoDeficiencia/ManutencaoVagasTipoDeficienciaEdit.vue"
        ),
    },
    {
      path: "/manutencao_vagas_tipo_deficiencia",
      name: "manutencaovagastipodeficiencia",
      meta: {
        allowedPermissions: ["deficiencia_vaga_index"],
      },
      component: () =>
        import(
          "@/views/ManutencaoVagasTipoDeficiencia/ManutencaoVagasTipoDeficienciaHome.vue"
        ),
    },
  ],
};

export { vagas_por_tipo_de_deficiencia };
